const pathsRewrittenToNext = [
  '/',
  '/l',
  '/flight-tracker',
  '/receipts',
  '/retirements',
];
const nextRoute = '/next';
const nextRegExp = new RegExp(`${nextRoute}\\b`);
const docsPathPrefix = '/docs';

//TODO: what about /blog? (fully static, next-based, but not from `wren/next`)

const prefixesRewrittenToNext = ['/join/', '/start/'];

export function isPathRenderedByNext(path: string) {
  return (
    pathsRewrittenToNext.includes(path) ||
    nextRegExp.test(path) ||
    path === docsPathPrefix ||
    path.startsWith(`${docsPathPrefix}/`) ||
    prefixesRewrittenToNext.some((prefix) => path.startsWith(prefix))
  );
}
